__turbopack_context__.v({
  "baseInput": "input-module__x4m50G__baseInput",
  "invalid": "input-module__x4m50G__invalid",
  "labelledStyles": "input-module__x4m50G__labelledStyles",
});
